
import { defineComponent, computed } from "vue";

// eslint-disable-next-line no-undef
const importAll = (requireContext: __WebpackModuleApi.RequireContext) => requireContext.keys().forEach(requireContext);
try {
  importAll(require.context("@/assets/icons", true, /\.svg$/));
} catch (error) {
  console.log(error);
}

interface SvgIcon {
  name: string;
  className?: string;
}

export default defineComponent({
  name: "SvgIcon",
  props: {
    name: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ""
    }
  },
  setup(props: SvgIcon) {
    const iconName = computed(() => `#icon-${props.name}`);
    const svgClass = computed(() => "svg-icon");

    return {
      iconName,
      svgClass
    };
  }
});
